import config from 'config'

const customerApi = `${config.apiHost}`

export default {
    getAutoMassSendingList: {
        url: `${customerApi}/oem-customer/api/auto_mass_sending`,
        type: 'GET',
    },
    getDetailTableList: {
        url: `/api/auto-record-detail-list`,
        // url: `${customerApi}/api/warning`,
        type: 'GET',
    },
}
